<template>
  <img :src="iconSrc" :title="channel.type | channelType">
</template>

<script>
  import facebookMessanger from '@/assets/img/logo/channels/facebook_messenger/facebook_messenger.svg'
  import viber from '@/assets/img/logo/channels/viber/viber.svg'
  import telegram from '@/assets/img/logo/channels/telegram/telegram.svg'
  import whatsapp from '@/assets/img/logo/channels/whatsapp/whatsapp.svg'
  import mobile from '@/assets/img/logo/channels/mobile/mobile.svg'
  import amioChat from '@/assets/img/logo/channels/amio-chat/amio_chat.svg'
  import email from '@/assets/img/logo/channels/email/email.svg'
  import rbm from '@/assets/img/logo/channels/rbm/rcs.svg'

  export default {
    props: {
      channel: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        amioChat,
        email,
        facebookMessanger,
        mobile,
        rbm,
        telegram,
        viber,
        whatsapp
      }
    },

    computed: {
      iconSrc() {
        if (this.channel.type === 'amio_chat') return this.amioChat
        if (this.channel.type === 'email') return this.email
        if (this.channel.type === 'facebook_messenger') return this.facebookMessanger
        if (this.channel.type === 'mobile') return this.mobile
        if (this.channel.type === 'rbm') return this.rbm
        if (this.channel.type === 'telegram') return this.telegram
        if (this.channel.type === 'viber') return this.viber
        if (this.channel.type === 'viber_business_messages') return this.viber
        if (this.channel.type === 'whatsapp') return this.whatsapp
      }
    }
  }
</script>
